// Purpose: An accessibility file included in the PDP to announce assistive text for the PDP

// This work was originally added as a part of EL-2059 that only accounts for Size/Width not being called when selected.
// For future work, this file should also account for colorway selection and general deselection of variant attributes

'use strict';

// Tracking Events
const TRACKING_PRODUCTDETAIL = 'tracking:productdetail';

// Containers
const $assistiveTextContainer = document.getElementById('assistive-text-container');
const $messageContainer = document.getElementById('pdp-message-container');

// Variables
const assistiveSizeText = $assistiveTextContainer ? $assistiveTextContainer.getAttribute('data-assistive-size-text') : '';
const assistiveWidthText = $assistiveTextContainer ? $assistiveTextContainer.getAttribute('data-assistive-width-text') : '';
const assistiveCupText = $assistiveTextContainer ? $assistiveTextContainer.getAttribute('data-assistive-cup-text') : '';

/**
 * Announces a message for screen readers by setting the text content of the message container.
 * @param {string} message - The message to announce.
 */
function announcePDPMessage(message) {
    $messageContainer.textContent = message;
}

const productDetailsAccessibility = {
    init: function () {
        document.addEventListener(TRACKING_PRODUCTDETAIL, function (event) {
            if (event.target.matches('#productDetails [data-attr="size-value"]')) {
                const isUnselectable = event.target.classList.contains('unselectable');
                if (!isUnselectable) {
                    announcePDPMessage(assistiveSizeText + ' ' + event.target.textContent);
                }
            }
        });

        document.addEventListener(TRACKING_PRODUCTDETAIL, function (event) {
            if (event.target.matches('#productDetails [data-attr="width-value"]')) {
                const isUnselectable = event.target.classList.contains('unselectable');
                if (!isUnselectable) {
                    announcePDPMessage(assistiveWidthText + ' ' + event.target.textContent);
                }
            }
        });

        document.addEventListener(TRACKING_PRODUCTDETAIL, function (event) {
            if (event.target.matches('#productDetails [data-attr="cup-value"]')) {
                const isUnselectable = event.target.classList.contains('unselectable');
                if (!isUnselectable) {
                    announcePDPMessage(assistiveCupText + ' ' + event.target.textContent);
                }
            }
        });

        // Play and Pause Listeners for Why You'll Love It
        document.addEventListener('click', function (event) {
            if (event.target.matches('.btn-play')) {
                announcePDPMessage('clicked, video playing');
            } else if (event.target.matches('.btn-pause')) {
                announcePDPMessage('clicked, video paused');
            }
        });
    }
};

productDetailsAccessibility.init();
